import React from "react";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import Home from "../../../../common/assets/data/home";
import ScrollAnimation from "react-animate-on-scroll";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useState } from "react";

function WhatVaidyoHas() {
  const data = Home.whatVaidyoHas;
  const [time, setTime] = useState("tab");
  // const interval =
  //     () => setTime(setInterval(function () {
  //         document.getElementById("tabData");
  //         // alert('3sec over');
  //     }, 2000))

  const interval = () =>
    setInterval(() => {
      setTime(
        console.log("test"),
        document.getElementById("tabData")
        // alert('3sec over');
      );
    }, 2000);

  console.log(time);
  return (
    <Section>
      <Container>
        <ScrollAnimation animateIn="animate__fadeIn">
          <SectionHeading heading={data.Heading} />
        </ScrollAnimation>
        <Tabs>
          <TabList
            className="flex justify-around font-bold"
            id="tabData"
            onClick={interval}
          >
            <Tab className="animation capitalize">Registration and Billing</Tab>
            <Tab className="animation capitalize">Patient Interaction</Tab>
            <Tab className="animation capitalize">Effective Reporting</Tab>
          </TabList>
          <TabPanel>
            <div className="grid lg:grid-cols-2 mt-5 container p-5 gap-5">
              <div className="animation group">
                <img src={data.img3} alt="img" className="aspect-video" />
              </div>
              <div className="my-auto">
                <p className="border-white rounded ">
                  Increased margins, lab efficiency, quicker turnaround times,
                  and a decrease in errors will help you grow and scale your
                  business. Tracking, testing, and reporting can all be
                  automated to save time, increase quality (QA/QC), and
                  eliminate human labour. Decision-making guidelines for
                  assessing test results and initiating appropriate billing.
                  Data integrity through the management, tracking, and
                  identification of patient samples
                </p>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="grid lg:grid-cols-2 mt-5 container p-5 gap-5">
              <div className="animation group">
                <img src={data.img2} alt="img" className="aspect-video" />
              </div>

              <div className="my-auto">
                <p className="border-white rounded ">
                  {" "}
                  Increased margins,lab efficiency, quicker turnaround times,
                  and a decrease in errors will help you grow and scale your
                  business.Increased margins, lab efficiency, quicker turnaround
                  times, and a decrease in errors will help you grow and scale
                  your business.Increased margins, lab efficiency, quicker
                  turnaround times, and a decrease in errors will help you grow
                  and scale your business.
                </p>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="grid lg:grid-cols-2 mt-5 container p-5 gap-5">
              <div className="animation group">
                <img src={data.img1} alt="img" className="aspect-video" />
              </div>
              <div className="my-auto">
                <p className="border-white rounded  ">
                  Inbuilt system reporting with dashboards that is sophisticated
                  and customizable A thorough audit trail that documents every
                  activity and event performed by the user and by the system
                  Extensive search capabilities for patients, tests, customers,
                  and data within the LIMS Real-time queues for each lab role
                  that represent workloads for the day. Support for many
                  workflows with a wide range of flexibility Streamlined
                  tracking and management of specimens in real-time Improved
                  laboratory data storage, analysis, and interpretation for
                  enormous volumes of data
                </p>
              </div>
            </div>
          </TabPanel>
        </Tabs>
        {/* <div className="flex  justify-between gap-3">
          <div className="flex">
            <img src={data.img1} alt="" className=" w-32 h-32 my-auto"/>
            <div>
            <p className="font-bold center border-white rounded mb-2 px-3">Registration and Billing</p>
            <p className="border-white rounded shadow-lg px-3">Increased margins, lab efficiency, quicker turnaround times, and a decrease in errors will help you grow and scale your business.</p>
            </div>
          </div>
          <div className="flex">
            <img src={data.img2} alt="" className="my-auto w-32 h-32"/>
            <div>
            <p className="font-bold px-3 mb-2">Patient Interaction</p>
            <p className="border-white rounded shadow-lg px-3">Increased margins, lab efficiency, quicker turnaround times, and a decrease in errors will help you grow and scale your business.</p>
            </div>
          </div>
          <div className="flex">
            <img src={data.img3} alt="" className="my-auto w-32 h-32"/>
            <div>
            <p className="font-bold px-3 mb-2">Effective Reporting</p>
            <p className="border-white rounded shadow-lg px-3">Increased margins, lab efficiency, quicker turnaround times, and a decrease in errors will help you grow and scale your business. </p>
            </div>
          </div>
        </div> */}
        {/* <div class="svg-wrapper">
  <svg height="60" width="500" xmlns="http://www.w3.org/2000/svg">
    <rect class="shape1" height="60" width="500" />
    <rect class="shape2" height="60" width="500" />
    <div class="text">Double Border Animation</div>
  </svg>
</div> */}
      </Container>
    </Section>
  );
}
export default WhatVaidyoHas;
